export class SocialMedia {
    public Facebook: string = "https://www.facebook.com/englishcoffeemethod/";
    public Instagram: string = "https://www.instagram.com/englishcoffeemethod/?hl=pt-br";
    public LinkedIn: string = "https://www.linkedin.com/in/english-coffee-6b32ab160/";
    public YouTube: string = "https://www.youtube.com/channel/UC7kQDtgb3FoZYuXOhLq_9jQ?view_as=subscriber";
}
